import {
	ButtonGroup,
	Heading,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalOverlay,
	Text,
} from '@chakra-ui/react';
import { ButtonComponent } from 'components/buttons/ButtonComponent';

import { productionTargetMessages } from '../variables/productionTargetMessages';

export const ModalSave = props => {
	const { isOpen, saveChanges, onClose, setSaveYear } = props;

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			size='xl'
			isCentered
		>
			<ModalOverlay />
			<ModalContent
				borderRadius={20}
				pt='20px'
			>
				<ModalCloseButton />
				<ModalBody>
					<Heading
						color='gray.700'
						mb={2}
						size='md'
					>
						{
							productionTargetMessages.MODAL
								.UPDATE_ANNUAL_PRODUCTION_TARGET
						}
					</Heading>
					<br />
					<Text color='gray.500'>
						{
							productionTargetMessages.MODAL
								.UPDATE_FUTURE_MONTHS_QUESTION
						}
					</Text>
				</ModalBody>
				<ModalFooter>
					<ButtonGroup>
						<ButtonComponent
							type='ghost'
							onClick={() => {
								setSaveYear(false);
								saveChanges();
							}}
							title={
								productionTargetMessages.LABELS
									.SAVE_FOR_SELECTED_MONTH
							}
						/>
						<ButtonComponent
							type='secondary'
							data-test='button-confirmar-salvar'
							onClick={() => {
								setSaveYear(true);
								saveChanges();
							}}
							title={
								productionTargetMessages.LABELS.SAVE_FOR_YEAR
							}
						/>
					</ButtonGroup>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};
